import { markUiObject as __markUi } from '@/i18n/display'
import axios from 'axios'
// 2026-10-14：版型详情显式保留错误状态，默认请求继续沿用原错误形状。
declare module 'axios' {
  interface AxiosRequestConfig { preserveErrorDetails?: boolean }
}
import { isTokenTimeout } from './auth'
import { notification } from 'ant-design-vue'
import store from '@/store'
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: 20000
})
service.interceptors.request.use(
  (config) => {
    // if(config.headers){
    //     config.headers.icode='978D058300C262E2'
    // }
    // console.log(config.url, 'config')
    if (store.getters.token) {
      // if (config.url == 'appointments/uploadImage') {
      //   config.headers['Content-Type'] = 'multipart/form-data'
      // }
      // config.headers.Authorization = `Bearer ${store.getters.token}`
      config.headers.token = store.getters.token
      // config.headers['Content-Type'] = 'application/json; charset=utf-8'
      if (isTokenTimeout()) {
        store.dispatch('user/logout')
        notification.open(__markUi({
          message: '登录超时',
          description: '登录超时，请重新登录。'
        }, {"message":"登录超时","description":"登录超时，请重新登录。"}))
        return Promise.reject(new Error('TOKEN已过期。'))
      }
    }

    return config
  },
  (error) => {
    return Promise.reject(error.config?.preserveErrorDetails ? error : (error.response?.data || error))
  }
)
service.interceptors.response.use(
  (response) => {
    const { success, message, data } = response.data
    if (success) {
      return response.data
    } else {
      const error=new Error(message)
      if(response.config.preserveErrorDetails) Object.assign(error,{code:response.data.code})
      return Promise.reject(error)
    }
  },
  (error) => {
    if (
      error.response &&
      error.response.data &&
      // 2026-09-06：环境切换时清理旧登录态，避免把审核或测试身份继续用于另一套数据。
      (error.response.data.code === 40901 || error.response.data.code === 401 || error.response.data.code === 8)
    ) {
      store.dispatch('user/logout')
      const environmentChanged = error.response.data.code === 40901
      notification.open({
        message: environmentChanged ? '服务环境已切换' : '登录超时',
        description: environmentChanged ? '请重新登录后继续操作。' : '登录超时，请重新登录。'
      })
    }
    return Promise.reject(error.config?.preserveErrorDetails ? error : (error.response?.data || error))
  }
)
export default service
